var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSortDescendingOutline20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.75 4.75L13.75 15.25",
  stroke: "#A5A7AD",
  strokeWidth: 1.5,
  strokeLinecap: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.25 15.25L6.25 4.75",
  stroke: "#0077FF",
  strokeWidth: 1.5,
  strokeLinecap: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.25 7.25L13.75 4.75",
  stroke: "#A5A7AD",
  strokeWidth: 1.5,
  strokeLinecap: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M3.75 12.75L6.25 15.25",
  stroke: "#0077FF",
  strokeWidth: 1.5,
  strokeLinecap: "round"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M16.25 7.25L13.75 4.75",
  stroke: "#A5A7AD",
  strokeWidth: 1.5,
  strokeLinecap: "round"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M8.75 12.75L6.25 15.25",
  stroke: "#0077FF",
  strokeWidth: 1.5,
  strokeLinecap: "round"
})));
export { SvgSortDescendingOutline20 as ReactComponent };